import React, { useEffect, useState } from "react";
import Footer from "../../../Kryzen Alpha App/Components//Footer/footer";
import StepRoutes from "../../../Kryzen Alpha App/Routes/steps_routes";
import ButtonWithSVG from "../../../Kryzen Alpha App/Components/layouts/button_with_svg";
import performRequest from "../../../Kryzen Alpha App/api/request";
import { Toast } from "../../../Kryzen Alpha App/CustomComponent/toast";
import DynamicFilterInput from "../../../Kryzen Alpha App/Components/layouts/filter.inpit";
import getFilteredURL from "../../../Kryzen Alpha App/Components/Functions/filters.getUrl";
import DynamicFilterSelect from "../../Components/layouts/filter.select";
import Pagination from "../../Components/layouts/pagination";
import FarmTrainingTable from "./Farm Training/farm_traing_table";
import { CustomErrorResponse } from "../../CustomComponent/custom_error_response";
import { FcLandscape } from "react-icons/fc";
import { RiFontSize } from "react-icons/ri";
import FarmTrainingChart from "./Farm Training/FarmTrainingChart";
import { useSelector } from "react-redux";
import { useNavigate, useLocation } from "react-router-dom";

const FarmTraining = () => {
  const store = useSelector((store) => store?.login?.user);
  const [refresh, setRefresh] = useState(false);
  const [filters, setFilters] = useState({
    startdate: "",
    enddate: "",
    name: "",
    generatedBy: "",
    farmTrainingEnrolled: "",
    refundRequested: 0,
  });
  const [page, setPage] = useState(1);
  const [showPage, setShowPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [data, setData] = useState([]);
  const [generatedBy, setGeneratedBy] = useState([]);
  const [upcomingData, setUpcomingData] = useState();
  const [farmTrainingDateList, setFramsTrainingDateList] = useState([]);

  const [farmTrainingGraphData, setFarmTrainingGraphData] = useState([]);
  const [farmTrainingFrom, setFarmTrainingFrom] = useState(30);
  const [selectedMonth, setSelectedMonth] = useState("");
  const [selectedYear, setSelectedYear] = useState(
    new Date().getFullYear().toString()
  );

  const showRefundTraining = filters.refundRequested === 1;

  const location = useLocation();
  const navigate = useNavigate();
  
  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const pageFromUrl = parseInt(params.get("page")) || 1;
    setPage(pageFromUrl);
  }, []);
  
  useEffect(() => {
    const params = new URLSearchParams(location.search);
    params.set("page", page);
    navigate({ search: params.toString() }, { replace: true });
  }, [page]);

  useEffect(() => {
    performRequest(
      "GET",
      getFilteredURL("/farmTraining/getFarmTraining/", page, filters)
    )
      .then((res) => {
        if (res.status === 200) {
          setData(res?.data);
          setTotalPages(Math.ceil(res?.data?.farmTrainingCount / 50));
        } else {
          Toast("error", "Error while getting Data!");
        }
      })
      .catch((err) => {
        CustomErrorResponse(err);
      });
    // .finally(() => setLoading(false));
  }, [refresh, page]);

  useEffect(() => {
    performRequest("GET", "/farmTraining/getUpcomingFarmTrainings")
      .then((res) => {
        if (res.status === 200) {
          setUpcomingData(res?.data?.upcomingTrainings);
        } else {
          Toast("error", "Error while getting Data!");
        }
      })
      .catch((err) => {
        CustomErrorResponse(err);
      });
    // .finally(() => setLoading(false));
  }, []);

  useEffect(() => {
    performRequest("GET", "/leads/getAllLeadsOwners")
      .then((res) => {
        if (res.data) {
          setGeneratedBy(
            res?.data?.filter(
              (el) =>
                el?.role === process.env.REACT_APP_ROLE_SALLE_ADMIN ||
                el?.role === process.env.REACT_APP_ROLE_SALLE ||
                el?.role === process.env.REACT_APP_ROLE_SALES_MANAGER
            )
          );
        }
      })
      .catch((err) => CustomErrorResponse(err));
  }, []);

  useEffect(() => {
    performRequest("GET", "/farmTraining/getFarmTrainingDates/")
      .then((res) => {
        if (res.status === 200) {
          setFramsTrainingDateList(res?.data?.trainingDates);
        } else {
          Toast("error", "Error while getting Data!");
        }
      })
      .catch((err) => {
        CustomErrorResponse(err);
      });
    // .finally(() => setLoading(false));
  }, [refresh, page]);

  useEffect(() => {
    performRequest("GET", getFilteredURL("/farmTraining/getAllFarmTraining"))
      .then((res) => {
        if (res.status === 200) {
          setFarmTrainingGraphData(res?.data?.allFarmTraining || []);
        } else {
          Toast("error", "Error while getting Data!");
        }
      })
      .catch((err) => {
        CustomErrorResponse(err);
      });
    // .finally(() => setLoading(false));
  }, []);

  return (
    <div className="page">
      <div className="page-wrapper">
        <div style={{ minHeight: "80vh" }}>
          <div className="page-header d-print-none">
            <div className="container-xl">
              <div className="row g-2 align-items-center">
                <div className="col">
                  <h2 className="page-title">
                    <FcLandscape className="fs-2  me-1" />
                    Farm Training
                  </h2>
                  <h4 className="text-muted">
                    <StepRoutes />
                  </h4>
                </div>
                <div className="col-auto ms-auto d-print-none">
                  <div className="d-flex d-none d-sm-block ">
                    <ButtonWithSVG
                      href={"/farm-training/new"}
                      buttonText="New Farm Training"
                      svg={
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          className="icon"
                          width="24"
                          height="24"
                          viewBox="0 0 24 24"
                          strokeWidth="2"
                          stroke="currentColor"
                          fill="none"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        >
                          <path stroke="none" d="M0 0h24v24H0z" fill="none" />
                          <path d="M12 5l0 14" />
                          <path d="M5 12l14 0" />
                        </svg>
                      }
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="page-body">
            <div className="container-xxl">
              <div className="row">
                <div className="col-md-3 col-sm-12 py-2">
                  {/* ✅ SUMMARY CARDS (LEFT STACKED) */}

                  <div className="row row-deck mb-3">
                    <div className="col-12 mb-3">
                      <div className="card bg-primary-lt card-sm">
                        <div className="card-body text-center">
                          <h1 className="display-6 fw-bold">
                            {upcomingData?.farmTrainingDate}
                          </h1>
                          <div className="fw-bold text-uppercase">
                            Upcoming Farm Training
                          </div>
                        </div>
                      </div>
                    </div>

                    <div className="col-12 mb-3">
                      <div className="card bg-primary-lt card-sm">
                        <div className="card-body text-center">
                          <h1 className="display-6 fw-bold">
                            {upcomingData?.totalEnrollments} / 25
                          </h1>
                          <div className="fw-bold text-uppercase">
                            Total Enrollments
                          </div>
                        </div>
                      </div>
                    </div>

                    <div className="col-12 mb-3">
                      <div className="card bg-primary-lt card-sm">
                        <div className="card-body text-center">
                          {upcomingData?.daysRemaining !== 0 ? (
                            <>
                              <h1 className="display-6 fw-bold">
                                {upcomingData?.daysRemaining}
                              </h1>
                              <div className="fw-bold text-uppercase">
                                Remaining Days
                              </div>
                            </>
                          ) : (
                            <>
                              <h1 className="display-6 fw-bold">👨‍🌾</h1>
                              <div className="fw-bold text-uppercase">
                                Farm Training Day
                              </div>
                            </>
                          )}
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="card p-2">
                    <div
                      id="faq-1"
                      className="accordion"
                      role="tablist"
                      aria-multiselectable="true"
                    >
                      <div>
                        <div className="accordion-header m-0" role="tab">
                          <button
                            className="accordion-button fs-3 d-md-none p-0"
                            data-bs-toggle="collapse"
                            data-bs-target="#faq-1-1"
                          >
                            <h3 className="m-1">Filter result</h3>
                          </button>
                        </div>
                        <div
                          id="faq-1-1"
                          className="accordion-collapse collapse d-md-none"
                          role="tabpanel"
                          data-bs-parent="#faq-1"
                        >
                          <div className="accordion-body pt-0">
                            <div className="row">
                              <div className="col-12">
                                <DynamicFilterInput
                                  label="Start Date:"
                                  value={filters.startdate}
                                  onChange={(e) =>
                                    setFilters({
                                      ...filters,
                                      startdate: e.target.value,
                                    })
                                  }
                                  type="date"
                                />
                              </div>
                              <div className="col-12">
                                <DynamicFilterInput
                                  label="End Date:"
                                  value={filters.enddate}
                                  onChange={(e) =>
                                    setFilters({
                                      ...filters,
                                      enddate: e.target.value,
                                    })
                                  }
                                  type="date"
                                />
                              </div>
                              <div className="col-12">
                                <DynamicFilterInput
                                  label="Search name/phone:"
                                  value={filters.name}
                                  onChange={(e) =>
                                    setFilters({
                                      ...filters,
                                      name: e.target.value,
                                    })
                                  }
                                  placeholder="search name..."
                                />
                              </div>

                              <div className="col-12">
                                <DynamicFilterSelect
                                  label="Farm Training Dates:"
                                  onChange={(e) => {
                                    setFilters({
                                      ...filters,
                                      farmTrainingEnrolled: e.target.value,
                                    });
                                  }}
                                  value={filters.farmTrainingEnrolled}
                                >
                                  <option value="">Select Date</option>
                                  {farmTrainingDateList &&
                                    farmTrainingDateList?.map((el, index) => {
                                      return (
                                        <option key={index} value={el}>
                                          {el}
                                        </option>
                                      );
                                    })}
                                </DynamicFilterSelect>
                              </div>

                              <div className="col-12">
                                <div className="col-12">
                                  <DynamicFilterSelect
                                    label="Generated By:"
                                    onChange={(e) => {
                                      setFilters({
                                        ...filters,
                                        generatedBy: e.target.value,
                                      });
                                    }}
                                    value={filters.generatedBy}
                                  >
                                    <option value="">select all</option>
                                    {generatedBy &&
                                      generatedBy?.map((lead, index) => {
                                        return (
                                          <option
                                            key={index}
                                            value={lead?.userName}
                                          >
                                            {lead?.userName}
                                          </option>
                                        );
                                      })}
                                  </DynamicFilterSelect>
                                </div>
                              </div>
                              <div className="col-12">
                                <div className="row mt-2">
                                  <div className="col-6">
                                    <button
                                      onClick={() => setRefresh(!refresh)}
                                      className="btn btn-success w-100"
                                    >
                                      Apply Filter
                                    </button>
                                  </div>
                                  <div className="col-6">
                                    <button
                                      onClick={() => {
                                        setFilters({
                                          startdate: "",
                                          enddate: "",
                                          name: "",
                                          generatedBy: "",
                                        });
                                        setRefresh(!refresh);
                                      }}
                                      className="btn btn-secondary w-100"
                                    >
                                      Reset Filter
                                    </button>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>

                        {/*  Second  Footer */}
                        <div className="accordion-body d-none d-md-block">
                          <div className="row">
                            <h3>Filter result</h3>
                            <div className="col-12">
                              <DynamicFilterInput
                                label="Start Date:"
                                value={filters.startdate}
                                onChange={(e) =>
                                  setFilters({
                                    ...filters,
                                    startdate: e.target.value,
                                  })
                                }
                                type="date"
                              />
                            </div>
                            <div className="col-12">
                              <DynamicFilterInput
                                label="End Date:"
                                value={filters.enddate}
                                onChange={(e) =>
                                  setFilters({
                                    ...filters,
                                    enddate: e.target.value,
                                  })
                                }
                                type="date"
                              />
                            </div>
                            <div className="col-12">
                              <DynamicFilterInput
                                label="Search name/phone:"
                                value={filters.name}
                                onChange={(e) =>
                                  setFilters({
                                    ...filters,
                                    name: e.target.value,
                                  })
                                }
                                placeholder="search name..."
                              />
                            </div>

                            <div className="col-12">
                              <DynamicFilterSelect
                                label="Farm Training Dates:"
                                onChange={(e) => {
                                  setFilters({
                                    ...filters,
                                    farmTrainingEnrolled: e.target.value,
                                  });
                                }}
                                value={filters.farmTrainingEnrolled}
                              >
                                <option value="">Select Date</option>
                                {farmTrainingDateList &&
                                  farmTrainingDateList?.map((el, index) => {
                                    return (
                                      <option key={index} value={el}>
                                        {el}
                                      </option>
                                    );
                                  })}
                              </DynamicFilterSelect>
                            </div>

                            <div className="col-12">
                              <div className="col-12">
                                <DynamicFilterSelect
                                  label="Generated By:"
                                  onChange={(e) => {
                                    setFilters({
                                      ...filters,
                                      generatedBy: e.target.value,
                                    });
                                  }}
                                  value={filters.generatedBy}
                                >
                                  <option value="">select all</option>
                                  {generatedBy &&
                                    generatedBy?.map((lead, index) => {
                                      return (
                                        <option
                                          key={index}
                                          value={lead?.userName}
                                        >
                                          {lead?.userName}
                                        </option>
                                      );
                                    })}
                                </DynamicFilterSelect>
                              </div>
                            </div>

                            <div className="col-12">
                              <div className="row mt-2">
                                <div className="col-6">
                                  <button
                                    onClick={() => setRefresh(!refresh)}
                                    className="btn btn-success w-100"
                                  >
                                    Apply Filter
                                  </button>
                                </div>
                                <div className="col-6">
                                  <button
                                    onClick={() => {
                                      setFilters({
                                        startdate: "",
                                        enddate: "",
                                        name: "",
                                        generatedBy: "",
                                      });
                                      setRefresh(!refresh);
                                    }}
                                    className="btn btn-secondary w-100"
                                  >
                                    Reset Filter
                                  </button>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  {(store.Role === process.env.REACT_APP_ROLE_ADMIN_S ||
                    store.Role === process.env.REACT_APP_ROLE_ADMIN) && (
                    <div className="mt-3 mb-3">
                      {!showRefundTraining && (
                        <button
                          onClick={() => {
                            setFilters((prev) => ({
                              ...prev,
                              refundRequested: 1,
                            }));
                            setPage(1);
                            setRefresh((r) => !r);
                          }}
                          className="btn btn-outline btn-danger w-100"
                        >
                          Refund Trainings
                        </button>
                      )}

                      {showRefundTraining && (
                        <button
                          onClick={() => {
                            setFilters((prev) => ({
                              ...prev,
                              refundRequested: 0,
                            }));
                            setPage(1);
                            setRefresh((r) => !r);
                          }}
                          className="btn btn-outline btn-success w-100"
                        >
                          Active Trainings
                        </button>
                      )}
                    </div>
                  )}
                </div>

                <div className="col-md-9 col-sm-12 py-2">
                  {/* 🔹 Chart Section */}
                  {(store.Role === process.env.REACT_APP_ROLE_ADMIN_S ||
                    store.Role === process.env.REACT_APP_ROLE_ADMIN) && (<div className="card mb-3">
                    <div className="card-header">
                      <h3 className="card-title">
                        Farm Training Enrollment Summary
                      </h3>

                      <div className="ms-auto">
                        <div className="d-flex gap-2">
                          {/* ✅ LAST DAYS DROPDOWN */}
                          <div className="dropdown">
                            <a
                              className="dropdown-toggle text-muted"
                              href="/"
                              onClick={(e) => e.preventDefault()}
                              data-bs-toggle="dropdown"
                            >
                              Last {farmTrainingFrom || 30} days
                            </a>

                            <div className="dropdown-menu dropdown-menu-end">
                              <span
                                className="dropdown-item"
                                role="button"
                                onClick={() => {
                                  setFarmTrainingFrom(7);
                                  setSelectedMonth("");
                                }}
                              >
                                Last 7 days
                              </span>

                              <span
                                className="dropdown-item"
                                role="button"
                                onClick={() => {
                                  setFarmTrainingFrom(15);
                                  setSelectedMonth("");
                                }}
                              >
                                Last 15 days
                              </span>

                              <span
                                className="dropdown-item"
                                role="button"
                                onClick={() => {
                                  setFarmTrainingFrom(30);
                                  setSelectedMonth("");
                                }}
                              >
                                Last 30 days
                              </span>

                              <span
                                className="dropdown-item"
                                role="button"
                                onClick={() => {
                                  setFarmTrainingFrom(60);
                                  setSelectedMonth("");
                                }}
                              >
                                Last 2 months
                              </span>

                              <span
                                className="dropdown-item"
                                role="button"
                                onClick={() => {
                                  setFarmTrainingFrom(90);
                                  setSelectedMonth("");
                                }}
                              >
                                Last 3 months
                              </span>
                            </div>
                          </div>

                          {/* ✅ MONTH DROPDOWN (SEPARATE) */}
                          <div className="dropdown">
                            <a
                              className="dropdown-toggle text-muted"
                              href="/"
                              onClick={(e) => e.preventDefault()}
                              data-bs-toggle="dropdown"
                            >
                              {selectedMonth
                                ? `Month: ${
                                    [
                                      "",
                                      "Jan",
                                      "Feb",
                                      "Mar",
                                      "Apr",
                                      "May",
                                      "Jun",
                                      "Jul",
                                      "Aug",
                                      "Sep",
                                      "Oct",
                                      "Nov",
                                      "Dec",
                                    ][Number(selectedMonth)]
                                  }`
                                : "Select Month"}
                            </a>

                            <div className="dropdown-menu dropdown-menu-end">
                              <span
                                className="dropdown-item"
                                onClick={() => {
                                  setSelectedMonth("01");
                                  setFarmTrainingFrom(30);
                                }}
                              >
                                January
                              </span>
                              <span
                                className="dropdown-item"
                                onClick={() => {
                                  setSelectedMonth("02");
                                  setFarmTrainingFrom(30);
                                }}
                              >
                                February
                              </span>
                              <span
                                className="dropdown-item"
                                onClick={() => {
                                  setSelectedMonth("03");
                                  setFarmTrainingFrom(30);
                                }}
                              >
                                March
                              </span>
                              <span
                                className="dropdown-item"
                                onClick={() => {
                                  setSelectedMonth("04");
                                  setFarmTrainingFrom(30);
                                }}
                              >
                                April
                              </span>
                              <span
                                className="dropdown-item"
                                onClick={() => {
                                  setSelectedMonth("05");
                                  setFarmTrainingFrom(30);
                                }}
                              >
                                May
                              </span>
                              <span
                                className="dropdown-item"
                                onClick={() => {
                                  setSelectedMonth("06");
                                  setFarmTrainingFrom(30);
                                }}
                              >
                                June
                              </span>
                              <span
                                className="dropdown-item"
                                onClick={() => {
                                  setSelectedMonth("07");
                                  setFarmTrainingFrom(30);
                                }}
                              >
                                July
                              </span>
                              <span
                                className="dropdown-item"
                                onClick={() => {
                                  setSelectedMonth("08");
                                  setFarmTrainingFrom(30);
                                }}
                              >
                                August
                              </span>
                              <span
                                className="dropdown-item"
                                onClick={() => {
                                  setSelectedMonth("09");
                                  setFarmTrainingFrom(30);
                                }}
                              >
                                September
                              </span>
                              <span
                                className="dropdown-item"
                                onClick={() => {
                                  setSelectedMonth("10");
                                  setFarmTrainingFrom(30);
                                }}
                              >
                                October
                              </span>
                              <span
                                className="dropdown-item"
                                onClick={() => {
                                  setSelectedMonth("11");
                                  setFarmTrainingFrom(30);
                                }}
                              >
                                November
                              </span>
                              <span
                                className="dropdown-item"
                                onClick={() => {
                                  setSelectedMonth("12");
                                  setFarmTrainingFrom(30);
                                }}
                              >
                                December
                              </span>
                            </div>
                          </div>

                          {/* ✅ YEAR DROPDOWN */}
                          <div className="dropdown">
                            <a
                              className="dropdown-toggle text-muted"
                              href="/"
                              onClick={(e) => e.preventDefault()}
                              data-bs-toggle="dropdown"
                            >
                              Year: {selectedYear}
                            </a>

                            <div className="dropdown-menu dropdown-menu-end">
                              {[
                                new Date().getFullYear(),
                                new Date().getFullYear() - 1,
                                new Date().getFullYear() - 2,
                                new Date().getFullYear() - 3,
                                new Date().getFullYear() - 4,
                              ].map((year) => (
                                <span
                                  key={year}
                                  className="dropdown-item"
                                  onClick={() =>
                                    setSelectedYear(year.toString())
                                  }
                                >
                                  {year}
                                </span>
                              ))}
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div
                      style={{
                        maxHeight: "400px",
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                      }}
                    >
                      {farmTrainingGraphData?.length > 0 && (
                        <FarmTrainingChart
                          farmTrainingGraphData={farmTrainingGraphData}
                          farmTrainingFrom={farmTrainingFrom}
                          selectedMonth={selectedMonth}
                          selectedYear={selectedYear}
                        />
                      )}
                    </div>
                  </div>)}

                  <div className="card mb-3">
                    <FarmTrainingTable
                      data={data?.farmTraining}
                      currentPage={page}
                      itemsPerPage={50}
                      showRefundTraining={showRefundTraining} // ⭐ IMPORTANT
                      onActionComplete={() => setRefresh((r) => !r)}
                    />

                    <div className="btn-list justify-content-center">
                      <div className="d-lg-none d-md-none mt-3 mb-3">
                        <ButtonWithSVG
                          href={"/farm-training/new"}
                          buttonText="New Farm Training"
                          svg={
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              className="icon"
                              width="24"
                              height="24"
                              viewBox="0 0 24 24"
                              strokeWidth="2"
                              stroke="currentColor"
                              fill="none"
                              strokeLinecap="round"
                              strokeLinejoin="round"
                            >
                              <path
                                stroke="none"
                                d="M0 0h24v24H0z"
                                fill="none"
                              />
                              <path d="M12 5l0 14" />
                              <path d="M5 12l14 0" />
                            </svg>
                          }
                        />
                      </div>
                    </div>

                    <Pagination
                      page={page}
                      setPage={setPage}
                      totalPages={totalPages}
                      pageDatalength={data?.farmTraining?.length}
                      showPage={showPage}
                      setShowPage={setShowPage}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <Footer />
      </div>
    </div>
  );
};

export default FarmTraining;
